import { forwardRef, useEffect, useRef, useState } from 'react';
import './GallerySection.css';
const GallerySection = forwardRef(({ scrollToNextSection }, ref) =>  {
    const gallerySliderRef = useRef(null);
    const gallerySliderRefHigh = useRef(null);
    const [images,setImages] = useState([]);
    const [imagesAll,setImagesAll] = useState([]);
    const [currentType,setCurrentType] = useState('Tudo');

    const [opacity, setOpacity] = useState(1);
    const [isScrolling, setIsScrolling] = useState(false);
    const [imageSelected, setImageSelected] = useState(null);
    useEffect(() => {
        // Caminho para o JSON dentro da pasta public
        fetch('/assets/json/galeria.json')
          .then((response) => {
            if (!response.ok) {
              throw new Error('Erro ao carregar o arquivo JSON');
            }
            return response.json();
          })
          .then((jsonData) => {
            setImages(jsonData);
            setImagesAll(jsonData);
          })
          .catch((error) => {
            console.error('Erro ao buscar o arquivo JSON:', error);
          });
      }, []);
    useEffect(() => {
      let timeoutId;
  
      const handleScroll = () => {
        setIsScrolling(true);
  
        // Limpa o temporizador anterior se houver
        clearTimeout(timeoutId);
  
        // Configura um temporizador para iniciar a transição de opacidade após a rolagem parar
        timeoutId = setTimeout(() => {
          setOpacity(0); // Começa a desaparecer gradativamente
        }, 10); // Inicia a transição de opacidade após 100ms
  
        // Configura um temporizador para restaurar a opacidade após a rolagem parar
        timeoutId = setTimeout(() => {
          setOpacity(1); // Restaura a opacidade
          setIsScrolling(false);
        }, 200); // Tempo para restaurar a opacidade após 1 segundo de inatividade
      };
  
      // Adiciona o ouvinte de evento de rolagem
      window.addEventListener('scroll', handleScroll);
  
      // Remove o ouvinte de evento quando o componente é desmontado
      return () => {
        clearTimeout(timeoutId);
        window.removeEventListener('scroll', handleScroll);
      };
    }, []);

    const handleCategoria = (type) => {
        setCurrentType(type);
        const filteredItems = type === 'Tudo' ? imagesAll : imagesAll.filter(item => item.type === type);
        setImages(filteredItems);
    }

    const handlePrev = () => {
        if(gallerySliderRef.current) {
            console.log(gallerySliderRef.current.offsetWidth)
            gallerySliderRef.current.scrollBy({
                left: -gallerySliderRef.current.offsetWidth,
                behavior:"smooth"
            })
        }
    };

    const handleNext = () => {
        if(gallerySliderRef.current) {
            gallerySliderRef.current.scrollBy({
                left: gallerySliderRef.current.offsetWidth,
                behavior:"smooth"
            })
        }
    };

    const handlePrevHigh = () => {
        if(gallerySliderRefHigh.current) {
            gallerySliderRefHigh.current.scrollBy({
                left: -gallerySliderRefHigh.current.offsetWidth,
                behavior:"smooth"
            })
        }
    };

    const handleNextHigh = () => {
        if(gallerySliderRefHigh.current) {
            gallerySliderRefHigh.current.scrollBy({
                left: gallerySliderRefHigh.current.offsetWidth,
                behavior:"smooth"
            })
        }
    };

    const handleSelected = (src) => {
        var selected = images.findIndex(img => img.src === src);
        setImageSelected(selected);
    }

    useEffect(() => {
    if (gallerySliderRefHigh.current && imageSelected !== null) {
        const timeoutId = setTimeout(() => {
            gallerySliderRefHigh.current.scrollBy({
                left: gallerySliderRefHigh.current.offsetWidth * imageSelected,
                behavior: "smooth"
            });
        }, 100); // Atraso de 100ms (ajuste conforme necessário)

        return () => clearTimeout(timeoutId); // Limpeza do timeout se o efeito for chamado novamente
    }
}, [imageSelected]);

    useEffect(() => {
        // Função para lidar com as setas do teclado
        const handleKeyDown = (event) => {
          if (event.key === 'ArrowRight') {
            handleNextHigh()
          } else if (event.key === 'ArrowLeft') {
            handlePrevHigh()
          }else if (event.key === 'Escape') {
            setImageSelected(null)
          }
        };
    
        window.addEventListener('keydown', handleKeyDown);
        return () => {
          window.removeEventListener('keydown', handleKeyDown);
        };
      }, []);
    return(
        <>
            <section id={"gallery-section"} className="gallery-section" ref={ref}>
                <div className='gallery-header'>
                    <h2>GALERIA DE IMAGENS</h2>
                   
                </div>
                <div className='gallery-body'>
                {Array.from({ length: 4 }).map((_, colIndex) => (
                    <div className={`col-${colIndex + 1}`} key={colIndex}>
                        {images
                            .filter((_, imgIndex) => imgIndex % 4 === colIndex)
                            .slice(0, 2) // Limita a 2 imagens por coluna
                            .map((image, imgIndex) => (
                                <div onClick={()=>handleSelected(image.src)} className='img-wrapper' key={imgIndex} >
                                    <img src={"/assets/img/galeria/"+image.src} alt={"img:" + image.src}/>
                                </div>
                            ))}
                    </div>
                ))}
</div>
                <div className='footer-gallery'>
    {images.slice(8, 11).map((image, index) => (
        <div onClick={()=>handleSelected(image.src)} className='img-wrapper' key={index}>
            <img src={"/assets/img/galeria/"+image.src} />
        </div>
    ))}
</div>
                <div className='gallery-body-mobile'>
                    <div className='gallery-slider' ref={gallerySliderRef}>
                        {
                            images.map((image,key)=>{
                                if(currentType === 'Tudo' || image.type===currentType)
                                return(
                                    <div style={{background:image.bg}} className='img-wrapper'>
                                        <img src={'/assets/img/galeria/'+image.src} alt={'Img: '+ image.src}/>
                                    </div>
                                )
                            })
                        }
                    </div>
                    <div className='slider-control-wrapper'>
                        <button onClick={handlePrev} id="slider-control-left"><img src="/assets/icons/angle-down.png"/></button>
                        <button onClick={handleNext} id="slider-control-right"><img src="/assets/icons/angle-down.png"/></button>
                    </div>
                    
                </div>

                {imageSelected != null && <div onClick={()=>setImageSelected(null)} className='gallery-slider-high'>
                    <div onClick={(e)=>e.stopPropagation()} className='gallery-slider-high-body'>
                        <i onClick={()=>setImageSelected(null)} className='fa fa-close'></i>
                        <div className='gallery-slider' ref={gallerySliderRefHigh}>
                            {
                                images.map((image,key)=>{
                                    return(
                                        <div style={{background:image.bg}} className='img-wrapper'>
                                            <img src={'/assets/img/galeria-high/'+image.src} alt={'Img: '+ image.src}/>
                                        </div>
                                    )
                                })
                            }
                        </div>
                        <div className='slider-control-wrapper'>
                            <button onClick={handlePrevHigh} id="slider-control-left"><img src="/assets/icons/angle-down.png"/></button>
                            <button onClick={handleNextHigh} id="slider-control-right"><img src="/assets/icons/angle-down.png"/></button>
                        </div>
                    </div>

                </div>}
                <div className="transaction">
                    <button style={{
                opacity,
                transition: 'opacity 0.2s ease' // Animação de transição de opacidade
                }}><img src="/assets/icons/angle-down.png"/></button>
                    </div>
            </section>
        </>
    )
});

export default GallerySection;